import { render } from "./FElectronicaView.vue?vue&type=template&id=2b08d56a"
import script from "./FElectronicaView.vue?vue&type=script&lang=js"
export * from "./FElectronicaView.vue?vue&type=script&lang=js"

import "./FElectronicaView.vue?vue&type=style&index=0&id=2b08d56a&scope=true&lang=css"

import exportComponent from "D:\\WGitHub\\Kubber\\kubber\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__